import { useStandardButtonStyles } from "../../styles/standardButtons";
import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography
} from "@material-ui/core";
import { toast } from "react-toastify";

const FlowBuilderAddNotifierModal = ({ open, onSave, onUpdate, data, close }) => {
  const classes = useStandardButtonStyles();
  const [destinationNumber, setDestinationNumber] = useState("");
  const [message, setMessage] = useState("Nuevo pedido recibido. Nombre: {{nombre}}");

  useEffect(() => {
    if (open && data) {
      setDestinationNumber(data.data?.destinationNumber || "");
      setMessage(data.data?.message || "Nuevo pedido recibido. Nombre: {{nombre}}");
    } else if (open) {
      setDestinationNumber("");
      setMessage("Nuevo pedido recibido. Nombre: {{nombre}}");
    }
  }, [open, data]);

  const handleSave = () => {
    if (!destinationNumber) {
      return toast.error("Por favor, ingresa el número destino");
    }

    if (data && data.id) {
      onUpdate({
        ...data,
        data: {
          ...data.data,
          destinationNumber,
          message
        }
      });
    } else {
      onSave({
        destinationNumber,
        message
      });
    }
    close();
  };

  return (
    <Dialog open={open} onClose={close} fullWidth maxWidth="sm">
      <DialogTitle>Configurar Notificador</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Envía un mensaje de texto a un número específico (ej. tu vendedor o tu sistema interno). El flujo continuará inmediatamente sin esperar respuesta.
        </Typography>
        
        <TextField
          label="Número destino (con código de país ej. 51999999999)"
          variant="outlined"
          fullWidth
          margin="normal"
          value={destinationNumber}
          onChange={(e) => setDestinationNumber(e.target.value)}
          placeholder="Ej: 51987654321"
        />

        <TextField
          label="Mensaje (puedes usar {{variables}} globales o del formulario)"
          variant="outlined"
          fullWidth
          margin="normal"
          multiline
          rows={4}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={close} className={classes.secondaryButton}>Cancelar</Button>
        <Button onClick={handleSave} className={classes.applyButton}>Guardar</Button>
      </DialogActions>
    </Dialog>
  );
};

export default FlowBuilderAddNotifierModal;
